import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { TLabelCase } from '../types/label-case.type';

export const bulkAssignLabelCaseValidationSchema = z.object({
  caseIds: z.array(z.string().min(1)).min(1),
  labelIds: z.array(z.string().min(1)).min(1),
});

export type TBulkAssignLabelCaseValidation = z.infer<typeof bulkAssignLabelCaseValidationSchema>;
export type TBulkAssignLabelCaseResponse = ApiResponse<TLabelCase>;

export const bulkAssignLabelCase = async (
  data: TBulkAssignLabelCaseValidation
): Promise<TBulkAssignLabelCaseResponse> => {
  const url = `/case/bulk-label`;
  const dataRequest = {
    caseIds: data.caseIds,
    labelIds: data.labelIds,
  };
  return axiosInstance.patch(url, dataRequest);
};

type UseBulkAssignLabelCaseMutationOptions<TContext = unknown> = {
  mutationConfigOptions?: TypedMutationConfig<typeof bulkAssignLabelCase, AxiosErrorCustom, TContext>;
};

export const useBulkAssignLabelCaseMutation = <TContext = unknown>({
  mutationConfigOptions,
}: UseBulkAssignLabelCaseMutationOptions<TContext>) => {
  const { ...rest } = mutationConfigOptions || {};
  return useMutation({
    mutationFn: bulkAssignLabelCase,
    ...rest,
  });
};
